import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { PagedResponse } from '@lib/core/models/paged-response';
import { API_URL } from '@lib/core/tokens/api.tokens';
import { GuaranteeApplication, GuaranteeApplicationSearchModel, GuaranteeApplicationStatus } from '../models/guarantee-application.interface';
import { MedicalServiceRequestBody } from '../models/prescription.interface';

@Injectable({
  providedIn: 'root',
})
export class GuaranteeApplicationsService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  searchGuaranteeApplications(search?: Partial<GuaranteeApplicationSearchModel>): Observable<PagedResponse<GuaranteeApplication>> {
    const payload = search ? search : { sortBy: 'status', sortDirection: 'desc' };

    return this.http.post<PagedResponse<GuaranteeApplication>>(`${this.apiUrl}/members/guarantee-applications/search`, payload);
  }

  getClientsMedicalServices(clientId: string, pageSize?: number, page?: number): Observable<PagedResponse<GuaranteeApplication>> {
    const options = {
      params: new HttpParams()
        .set('PageSize', pageSize ?? 10)
        .set('page', page ?? 1)
        .set('sortBy', 'phoneNumber')
        .set('sortDirection', 'desc'),
    };
    return this.http.get<PagedResponse<GuaranteeApplication>>(`${this.apiUrl}/members/${clientId}/guarantee-applications`, options);
  }

  getGuaranteeApplicationById(memberId: string, guaranteeApplicationId: string): Observable<GuaranteeApplication> {
    return this.http.get<GuaranteeApplication>(`${this.apiUrl}/members/${memberId}/guarantee-applications/${guaranteeApplicationId}`);
  }

  postMedicalService(memberId: string, medicalService: MedicalServiceRequestBody) {
    return this.http.post<Partial<GuaranteeApplication>>(`${this.apiUrl}/members/${memberId}/guarantee-applications`, medicalService);
  }

  sendMedicalServiceToGuarantation(clientId: string, medicalService: GuaranteeApplication) {
    const payload: GuaranteeApplication = {
      ...medicalService,
      status: GuaranteeApplicationStatus.Processed,
    };
    return this.http.put(`${this.apiUrl}/members/${clientId}/guarantee-applications/${medicalService.id}`, payload);
  }

  processGuaranteeApplication(memberId: string, guaranteeApplicationId: string) {
    return this.http.post(`${this.apiUrl}/members/${memberId}/guarantee-applications/${guaranteeApplicationId}/process`, {});
  }
}